var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7438 0.638485V5.61454C10.7438 7.31558 9.39614 8.69579 7.7352 8.69579H2.13667L3.99302 6.79462C4.2334 6.54844 4.26132 6.14184 4.02869 5.88772C3.78211 5.61613 3.38199 5.60977 3.12765 5.87025L0.182611 8.88638C-0.0608704 9.13574 -0.0608704 9.54233 0.182611 9.79169L3.1292 12.8094C3.25327 12.9365 3.40836 13 3.57895 13C3.73403 13 3.90462 12.9365 4.02869 12.8094C4.27682 12.5553 4.27682 12.1582 4.02869 11.9041L2.13667 9.98228H7.7352C10.0909 9.98228 12 8.02712 12 5.61454V0.638485C12 0.285889 11.7208 0 11.3766 0H11.3688C11.0245 0 10.7454 0.285889 10.7454 0.638485H10.7438Z",
    fill: "#FFF057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.30959f4a17f667afc2f39d11748607b8.svg";
export { ForwardRef as ReactComponent };